import { Paper, Title } from '@mantine/core';
import { ErrorRouteComponent, useParams } from '@tanstack/react-router';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CommonError, FullMainHeight } from '@ui';

export const ErrorPage: ErrorRouteComponent = ({ error, reset }) => {
  const { t } = useTranslation();
  const { accountId } = useParams({ strict: false });
  const [mode] = useState<'create' | 'edit'>(accountId ? 'edit' : 'create');

  return (
    <FullMainHeight.Root>
      <FullMainHeight.Header>
        <Paper>
          <Title order={2}>
            {mode === 'create'
              ? t('accounts.add_account')
              : t('accounts.edit_title')}
          </Title>
        </Paper>
      </FullMainHeight.Header>
      <FullMainHeight.Content>
        <CommonError
          description={t('common.error.pageError')}
          error={error}
          reset={reset}
        />
      </FullMainHeight.Content>
    </FullMainHeight.Root>
  );
};

export default ErrorPage;
